import * as React from "react";
import {BasemapGalleryItemData} from "./basemap-gallery-item.data";

import "./basemap-gallery-item.scss";
import {FormatUtils} from "../../../../utils/format-utils";
import {Image} from "semantic-ui-react";
import {Icon} from "../../icon/icon";

export interface BasemapGalleryItemProps {
    isSelected: boolean;  // widgetsSearch is also the type for configuration object
    data: BasemapGalleryItemData;
    onClick: () => any;
}

export class BasemapGalleryItem extends React.Component<BasemapGalleryItemProps, any> {

    constructor(props: BasemapGalleryItemProps) {
        super(props);
    }

    render() {
        const {data, isSelected} = this.props;
        const css = `basemap-gallery-item${isSelected ? " selected" : ""}${data.isPlaceholder ? " placeholder" : ""}`;
        const itemTitle = FormatUtils.formatTitle(data.title);
        return (
            <li
                className={css}
                onClick={() => this.props.onClick()}>
                <div className="thumbnail-wrapper">
                    {data.thumbnailUrl? <Image src={data.thumbnailUrl} alt={itemTitle} />:
                        <Icon name="map" />}
                </div>
                <div className="geo-basemap-gallery-item-label">
                    {itemTitle}
                </div>
            </li>
        );
    }
}
